module.exports = "module.exports = __webpack_public_path__ + \"static/media/pageHeader.360ab48e.template\";"